import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { api } from '../services/api';
import { fetchWithCache } from '../services/cache';

const FooterContainer = styled.footer`
  background-color: ${({ theme }) => theme.colors.text};
  color: white;
  padding: 3rem 1rem;
`;

const FooterContent = styled.div`
  max-width: ${({ theme }) => theme.breakpoints.large};
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  margin-bottom: 2rem;
`;

const Column = styled.div`
  h3 {
    color: ${({ theme }) => theme.colors.secondary};
    margin-bottom: 1rem;
  }
  p, a {
    color: #ccc;
    line-height: 1.6;
    text-decoration: none;
    display: block;
    margin-bottom: 0.5rem;
  }
  a:hover {
    color: white;
  }
`;

const Copyright = styled.div`
  text-align: center;
  border-top: 1px solid #444;
  padding-top: 2rem;
  color: #888;
`;

const Footer = () => {
  const [footerData, setFooterData] = useState(null);

  useEffect(() => {
    fetchWithCache('homeData', () => api.get('/home'), (data) => {
      if (data && data.footer) {
        setFooterData(data.footer);
      }
    });
  }, []);

  return (
    <FooterContainer>
      <FooterContent>
        <Column>
          <h3>26Minutes Ministry</h3>
          <p>Empowering individuals to know, live, and share the Word of God.</p>
          <br/>
          {footerData && (
              <>
                <p>{footerData.address}</p>
                <p>{footerData.phone}</p>
                <p>{footerData.contactInfo}</p>
              </>
          )}
        </Column>
        
        <Column>
          <h3>Quick Links</h3>
          <Link to="/">Home</Link>
          <Link to="/about">About Us</Link>
          <Link to="/news">News</Link>
          <Link to="/workshops">Workshops</Link>
          <Link to="/outreach">Outreach</Link>
        </Column>

        <Column>
           <h3>More</h3>
           <Link to="/team">Our Team</Link>
           <Link to="/gallery">Gallery</Link>
           <Link to="/donate">Donate</Link>
           <Link to="/contact">Contact Us</Link>
           <Link to="/admin/login">Admin Login</Link>
        </Column>
      </FooterContent>
      
      <Copyright>
        <p>&copy; {new Date().getFullYear()} The 26Minutes Ministry. All rights reserved.</p>
      </Copyright>
    </FooterContainer>
  );
};

export default Footer;
